import React from "react";
import { MemoryRouter, Route, Routes } from "react-router-dom";
import FormLayout from "../../NewFormBuilder";

interface InterfaceWidgetProps {
  formId: string;
}

export const InterfaceWidget: React.FC<InterfaceWidgetProps> = ({ formId }) => {
  return (
    <MemoryRouter initialEntries={[`/v2/interface/${formId}`]}>
      <Routes>
        <Route path="/v2/interface/:formId" element={<FormLayout />} />
      </Routes>
    </MemoryRouter>
  );
};
